/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamVideoOffIcon16Solid = forwardRef('TechCamVideoOffIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.707.793A1 1 0 0 0 .293 2.207L1.36 3.274A2.5 2.5 0 0 0 0 5.5v5A2.5 2.5 0 0 0 2.5 13h6c.712 0 1.355-.298 1.81-.776l2.983 2.983a1 1 0 0 0 1.414-1.414l-13-13Z" }),
        React.createElement("path", { d: "M16 11.08c0 .727-.738 1.184-1.368.93L5.622 3H8.5A2.5 2.5 0 0 1 11 5.5v1l3.427-2.399a1 1 0 0 1 1.573.82v6.158Z" })));
});
